export const FEATURE_FLAG_COOKIE = 'enabled-features';

export enum DevelopedFeatures {
  MembershipTimelineRecognitions = 'membership-timeline-recognitions',
  NotificationTableFilters = 'notification-table-filters',
  NotificationTableSorting = 'notification-table-sorting',
  PushNotifications = 'push-notifications',
  PwaNotificationsBadge = 'pwa-notifications-badge',
  RandomContentIndicator = 'random-content-indicator',
  TimeZoneSelectProfile = 'time-zone-select-profile',
}
